import CargoCompanyDetailsParams from "./cargo-company-details-params";
import CargoCompanyDetails from "./cargo-company-details";
import useAsyncData from "../../../../hooks/use-async-data";
import cargoCompanyService from "../../cargo-company.service";

const useCargoCompanyDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<CargoCompanyDetails | null>(null);

  const load = async (
    params: CargoCompanyDetailsParams,
    signal: AbortSignal
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoCompany = await cargoCompanyService.getCargoCompanyDetails(
        params,
        signal
      );

      setData(cargoCompany);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setIsLoading(true);
    setIsError(false);

    setData(null);
  };

  return {
    isLoading,
    isError,
    data,
    load,
    reset,
  };
};

export default useCargoCompanyDetails;
